export default __webpack_public_path__ + "static/light blue flower-ef4021ce1c7bfa047098575d7da70526.png";